import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { TickIcon } from 'components/icons'

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.4);
  }
`

const Bubble = styled.div<{ color: string; delay?: string }>`
	position: absolute;
	width: 24px;
	height: 24px;
	background-color: ${({ color }) => color};
	border-radius: ${({ theme }) => theme.borderRadiuses.round};
	animation: ${pulse} linear 1s infinite alternate ${({ delay }) => delay || '0s'};
`

const ShouldAnimateWrapper = styled.div`
	position: absolute;
	display: grid;
	place-items: center;
`

const StyledTickIcon = styled(TickIcon)<{ shouldAnimate: boolean }>`
	z-index: ${({ theme }) => theme.zIndexes.high};
	background-color: ${({ shouldAnimate, theme }) =>
		shouldAnimate ? '#1cab00' : theme.colors.light.surfaceInteractive};
	border-radius: ${({ theme }) => theme.borderRadiuses.round};
`

export const TickWrapper = styled.span`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	top: -13px;
	right: -13px;
	width: 24px;
	height: 24px;
	color: ${({ theme }) => theme.colors.light.surface};
	background-color: ${({ theme }) => theme.colors.light.surfaceInteractive};
	border: 2px solid ${({ theme }) => theme.colors.light.surface};
	border-radius: ${({ theme }) => theme.borderRadiuses.round};
	z-index: ${({ theme }) => theme.zIndexes.above};
`

const Tick = ({
	shouldAnimate = false,
	outerColor = '#abd6a1',
	innerColor = '#c0edb4',
}: {
	shouldAnimate?: boolean
	outerColor?: string
	innerColor?: string
}) => (
	<TickWrapper>
		<StyledTickIcon shouldAnimate={shouldAnimate} />
		{shouldAnimate && (
			<ShouldAnimateWrapper>
				<Bubble color={outerColor} />
				<Bubble color={innerColor} delay="1s" />
			</ShouldAnimateWrapper>
		)}
	</TickWrapper>
)

export default Tick
